import {DistanceConstraint} from './DistanceConstraint.ts';
import {DelayConstraint} from './DelayConstraint.ts';

export class PointerActivationConstraints {
  static Delay = DelayConstraint;
  static Distance = DistanceConstraint;
}
